import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/Service/event.service';
import { RollCallService } from 'src/app/Service/roll-call.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { PaginationTableService } from '../shared/pagination/pagination-table/pagination-table.service';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as L from 'leaflet';
import { CatGeneric } from 'src/app/models/shared/cat-generic';
import { from, Observable } from 'rxjs';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/Service/user.service';
import { NgOption } from '@ng-select/ng-select';
import { utilsApps } from 'src/app/helpers/utils-app';

@Component({
  selector: 'app-roll-call',
  templateUrl: './roll-call.component.html',
})
export class RollCallComponent implements OnInit, OnDestroy {

  private readonly datePipe: DatePipe = new DatePipe('en-US');

  protected dataInformation = <any>[];
  protected isPostBack = false;

  protected msgDataEmpty: string = 'No encontramos resultados. Ingresa una nueva búsqueda';

  protected form: FormGroup;

  protected pdfUrlDoc: SafeResourceUrl = "";

  protected idCompany: string = "";

  //Variables of pagination
  protected totalPages: any[] = [];
  protected currentPage: number = 1;
  private totalRows: number = 0;

  //Data of modal
  protected userView: any;
  protected selectedObjectModal: any;
  private viewImage: any;
  protected arrayObjectsUser = [{ name: 'selfie' }, { name: 'document' }, { name: 'evidence' }];
  protected userViewGeolocations: any;

  private readonly googleMapsUrl: string = 'https://www.google.com/maps/search/?api=1&query=';

  /** For design of maps for details of register */
  private readonly customLeafIcon = L.DivIcon.extend({
    options: {
      html: "<div style='background-color:#4838cc;' class='marker-pin'></div>",
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    },
  });


  //Nuevas variables para los componentes nuevos
  public totalPage: number = 1;
  public actualPage: number = 1;
  public dataRegisterSelected: any;
  @ViewChild("mdlView", { static: true })
  mdlView: TemplateRef<any>;

  @ViewChild("mdlFilterData", { static: true })
  mdlFilterData: TemplateRef<any>;

  @ViewChild("viewImage", { static: true })
  modalImage: TemplateRef<any>;
  public dataSelected: any;//Se almacena la informacion del registro seleccionado
  public filters: string = ``;

  userCtrl = new FormControl('');
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;

  _dataFilter: any;

  filteredUsers: Observable<CatGeneric[]>;
  _usersSelected: CatGeneric[] = [];

  public statusCatalog: NgOption[] = [
    { value: 'approved', label: 'Aprobado' },
    { value: 'rejected', label: 'Rechazado' },
    { value: 'pending', label: 'Pendiente' }
  ];

  _util = new utilsApps();

  constructor(
    private readonly translateService: TranslateService,
    private readonly eventService: EventService,
    private readonly rollCallService: RollCallService,
    private readonly _modalService: NgbModal,
    private readonly _config: NgbModalConfig,
    private __userService: UserService,
    private fb: FormBuilder,
    private readonly paginationTableService: PaginationTableService,
    private readonly sanitizer: DomSanitizer,
  ) {
    //Configuración para modal global
    _config.backdrop = 'static';
    _config.keyboard = false;

    this.filteredUsers = this.userCtrl.valueChanges.pipe(
      switchMap((filterInput: string) => from(filterInput ? this._filterUsers(filterInput) : this._filterUsers(''))),
    );
  }


  private async _filterUsers(value: string): Promise<CatGeneric[]> {
    const filterValue = value.toLowerCase();
    console.log("filterValue=>", filterValue);
    return await this.getAllUser(filterValue);
  }



  private async getAllUser(filterValue: string): Promise<Array<CatGeneric>> {
    try {
      let idCompany = localStorage.getItem('_company') || 1;
      let branchId = localStorage.getItem('_branch') || 1;


      if (filterValue.length > 0) {
        const response: any = await this.__userService.getAllUser(idCompany, branchId, filterValue);
        if (response && response.code == "SUCCESS" && response.content) {
          const content: any = JSON.parse(response.content);
          if (content.records.length == 0) {
            return [];
          }
          console.log("content=>", content);

          const users = content.records.map((user: any) => {
            //Recorre el arreglo de usuarios y los mapea
            //console.log("user=>", user);
            let checkUser = this._usersSelected.some(x => x === user.id);
            //console.log("checkUser=>", checkUser);
            return {
              id: user.id,
              name: user.name,
              value: user.contextual,
              description: user.platformId,
              checked: checkUser
            };
          });
          return users;
        }
        return [];
      }
      else
        return [];
    } catch (error) {
      return [];
    }
  }

  public ngOnInit(): void {
    this.currentPage = parseInt(localStorage.getItem('currentPage') ?? this.paginationTableService.resetPageCurrent().toString());

    let _companyFilter = localStorage.getItem('_company');
    this.idCompany = _companyFilter ?? "";
    this.filters = `companyId::${this.idCompany}`;
    console.log(this.idCompany);

    this.getDataLanguage();
    this.initForm();
    this.loadData(this.currentPage, this.filters);


  }

  /** For when the page is closed */
  public ngOnDestroy(): void {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('searchField');
  }

  /**
   * Method for translate the message of empty grid
   * In this, we subscribe to observable of translateService for get the message of empty grid
   * and save the result in msgDataEmpty variable
   */
  private getDataLanguage() {
    this.translateService.stream('common.msgEmptyGrid').subscribe((res: string) => {
      this.msgDataEmpty = res;
    });
  }

  private initForm(): void {
    this.form = this.fb.group({
      status: ['', []],
      dateStart: [this._util.getDateInitMonth(), []],
      dateEnd: [new Date(), []]
    });
  }

  private async loadData(page: number = 1, filters?: any) {
    try {
      this.eventService.startLoadingData();
      let response: any;
      response = await this.rollCallService.getAllRollCall(this.idCompany, page, filters);

      if (response?.code === "SUCCESS") {
        response.content = JSON.parse(response?.content);
        this.dataInformation = response?.content?.records;
        this.totalPage = response?.content?.pages;
      } else {
        this.eventService.errorMessage(1);
      }
    } catch (error) {
      console.log(error);
      this.eventService.errorMessage(1);
    } finally {
      this.eventService.completeLoadingData();
    }
  }

  /** Clean the filters for data list */
  protected removeFilter(): void {
    this.form.patchValue({
      ddlUser: ''
    });
    this.currentPage = this.paginationTableService.resetPageCurrent();
    this.loadData();
  }

  protected openModal(content: any, data: any): void {
    this.userView = data;
    this._modalService.open(content, { size: 'xl' });
  }
  protected closeModal(): void {
    this.userView = null;
    this._modalService.dismissAll();
  }


  protected openModalImage(content: any): void {
    this.viewImage = this._modalService.open(content, { size: 'xl' });
  }
  protected closeModalImage() {
    this.selectedObjectModal = undefined;
    this.pdfUrlDoc = undefined;
    this.viewImage.close();
  }
  /**
   * Method to get base64 of object, and continued with view image or download file
   * @param pathObject path of object
   * @param isView know if we view image or download file
   * @param contentModal modal to activate
   */
  protected getObject(pathObject: string, typeObject: string, isView: boolean, contentModal: any): void {
    this.eventService.startLoadingData();
    this.rollCallService.getDataFromUser(pathObject).subscribe({
      next: (response: any) => {
        console.log(response);

        this.selectedObjectModal = response?.content;
        if (typeObject === "document") {
          this.pdfUrlDoc = this.createPdfUrl(this.selectedObjectModal);
        }

        if (isView) {
          this.openModalImage(contentModal);
        } else {
          this.downloadFile(typeObject);
        }

      },
      complete: () => { this.eventService.completeLoadingData(); },
      error: (msg) => {
        console.log(msg);
        this.eventService.completeLoadingData();
        this.translateService.stream('common.error500').subscribe((res: string) => {
          this.eventService.errorMessage(0, res);
        });
      }
    });
  }

  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  createPdfUrl(base64: string): SafeResourceUrl {
    const blob = this.base64ToBlob(base64, 'application/pdf');
    const url = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  protected downloadFile(pathObject: string) {

    let isPdf: boolean = pathObject === "document";

    const filePath: string = (isPdf) ? "data:application/pdf;base64," : "data:image/jpeg;base64,";
    const fileExt: string = (isPdf) ? ".pdf" : ".jpg";

    const link = document.createElement('a');
    link.href = filePath + this.selectedObjectModal;
    link.download = "file_" + pathObject + "_" + this.datePipe.transform(new Date(), 'yyyyMMdd_HHmmss') + fileExt;
    link.click();
  }


  /** Method for send data for back generate excel and export for final user */
  protected async onExportExcel() {
    try {
      this.eventService.startLoadingData();
      const response: any = await this.rollCallService.getReportExcel(this.filters);
      if (response && response.code === "SUCCESS") {
        const file = this.b64toBlob(response.content, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        const objectUrl = URL.createObjectURL(file);
        const link: any = document.createElement('a');
        link.href = objectUrl;
        link.download = name;
        link.click();

        // Liberar la URL de objeto
        URL.revokeObjectURL(objectUrl);

      } else {
        this.eventService.errorMessage(1);
      }
    } catch (error) {
      this.eventService.errorMessage(1);
    } finally {
      this.eventService.completeLoadingData();
    }
  }



  //Nuevos metodos para los componentes nuevos
  protected changePage($event: any): void {
    this.actualPage = $event;
    this.loadData(this.actualPage, this.filters);
  }

  public onFilter(filters: any) {
    if (filters.event === 'filter') {
      this.onFilterData(filters.event, filters.data);
    }

    if (filters.event === 'advancedFilter') {
      this._usersSelected = [];
      this.openModal(this.mdlFilterData, filters.users);
    }

    if (filters.event === 'report') {
      console.log(filters.data);
      this.onFilterData(filters.event, filters.data);
    }

    if (filters.event === 'reset') {
      this.currentPage = 1;
      this.filters = `companyId::${this.idCompany}`;
      this.loadData(this.actualPage, this.filters);
    }
  }
  public onAction(data: any) {

    console.log("onAction", data);

    if (data.event === 'view') {
      this.openModal(this.mdlView, data.data);
      this.dataRegisterSelected = data.data;
    }

    if (data.event === 'advancedSearch') {
      this.openModal(this.mdlView, data.data);
      this.dataRegisterSelected = data.data;
    }

    if (data.event === 'close') {
      this.closeModal();
    }

    if (data.event === 'viewFile') {
      this.dataSelected = data;
      this.openModalImage(this.modalImage);
    }

    if (data.event === 'viewLocation') {
      this.dataSelected = data;
      this.openModalImage(this.modalImage);
    }


  }

  public onFilterData(event: any, data: any) {
    let filters = 'companyId::' + this.idCompany;

    if (data.users) {
      filters += `,personId@in::${data.users.join('#')}`;
    }

    if (data.dateStart && data.dateEnd) {

      const fechaStart = data.dateStart;
      const fechaFinal = data.dateEnd;
      let periodStartHour = "00:00";
      let periodEndHour = "23:59";

      let dateStart = this._util.fnDateToString(fechaStart, "-") + "T" + periodStartHour + ":00" + this._util.GetTimeZoneOffset();
      let dateEnd = this._util.fnDateToString(fechaFinal, "-") + "T" + periodEndHour + ":59" + this._util.GetTimeZoneOffset();

      let creationDate = dateStart + '%23' + dateEnd;
      filters += ',creationDate@bt::' + creationDate;
    }

    if (data.status) {
      filters += `,status@in::${data.status}`;
    }

    if (data.location) {
      let coordenadas = data.location.split(',');
      filters += `,sourceLatitude::${coordenadas[0]},sourceLongitude::${coordenadas[1]}`;
    }

    this.filters = filters;
    this.currentPage = 1;
    if (event === 'report') {
      this.onExportExcel();
    } else {
      this.loadData(this.actualPage, this.filters);
    }

  }


  private convertirFecha(fecha) {
    // Crear un nuevo objeto Date a partir de la fecha proporcionada
    const nuevaFecha = new Date(fecha);

    // Formatear la fecha en ISO 8601 con la zona horaria
    const fechaFormateada = nuevaFecha.toISOString().replace('T00:00:00.000Z', 'T00:00:00-06:00');

    return fechaFormateada;
  }



  private async getDataObject(idObject: string, typeObject: string) {
    try {
      const response: any = await this.rollCallService.getDataObject(idObject);
      if (response && response.code === "SUCCESS") {
        //Convert the response to a JSON object
        const getDataObject = response.content;
        let file: any;
        switch (typeObject) {
          case "image":
            file = this.b64toBlob(getDataObject, 'image/jpeg');
            break;
          case "document":
            file = this.b64toBlob(getDataObject, 'application/pdf');
            break;
          default:
            file = null;
            break;
        }
        return file;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public showGeolocalitation(typeObject: string, coord: any) {
    this.dataSelected = {
      typeObject, coord
    };
    this._modalService.open(this.modalImage, { size: 'xl' });
  }

  onClose() {
    this._usersSelected = [];
    this.userCtrl.setValue('');
    this.initForm();
    this.closeModal();
  }

  onSearch() {
    this._dataFilter = this.form.value;
    this._dataFilter.users = this._usersSelected.map((x) => x.value);
    console.log("this._dataFilter=>", this._dataFilter);
    this.onFilterData("filters.event", this._dataFilter);
    this.initForm();
    this.closeModal();
  }

  onSelected(event: any) {
    let user = this._usersSelected.some(x => x.id === event.option.id);
    if (!user) {
      this._usersSelected.push(event.option.value);
    }
    this.userCtrl.setValue('');
    console.log("_usersSelected=>", this._usersSelected);
  }


  removeUser(user: CatGeneric): void {
    const index = this._usersSelected.indexOf(user);

    if (index >= 0) {
      this._usersSelected.splice(index, 1);
    }
  }

}
